import styled from 'styled-components'

import { breakpoints, colors } from '@/styles'
import { Point, PointFilled } from '@/components/icons'

const MapContainer = styled.div`
  width: 100%;
  height: 350px;
  z-index: 0;
  @media screen and (max-width: ${breakpoints.phoneMax}) {
    width: 100%;
    height: 270px;
  }
`

const MarkerContainer = styled.div`
  position: absolute;
  border-radius: 100%;
  top: -42px;
  left: -19px;
  padding: 5px;
  color: ${colors.white};
`

const MarkerWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

const StyledPointFilled = styled(PointFilled)`
  width: 25px;
  height: 30px;
  position: absolute;
`

const StyledPoint = styled(Point)`
  width: 25px;
  height: 30px;
  position: absolute;
`

const IconWrapper = styled.div`
  position: absolute;
  z-index: 201;
  width: 20px;
  height: 20px;
  top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
`

const CenterLocation = styled.div`
  border-radius: 50%;
  border: none;
  color: ${colors.black};
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  width: 29px;
  height: 29px;
  position: absolute;
  bottom: 80px;
  right: 9px;
  z-index: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: all 0.2s ease-in;

  &:hover {
    background: #f2f2f2;
  }

  button {
    background-color: transparent;
    display: flex;
  }
`

export {
  MapContainer,
  MarkerContainer,
  MarkerWrapper,
  StyledPointFilled,
  StyledPoint,
  IconWrapper,
  CenterLocation
}
